import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

import styles from "../../../styles/patient-page-modules/addDeviceModal.module.css";
import Spinner from "../../../components/spinner";
import { BASE_URL } from "../../../utils/constants";
import { useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { handleApiError } from "../../../utils/handleApiError";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";

import Button from "../../button-v1";

const AddProviderModal = ({
  isOpen,
  onClose,
  render,
  reRenderer,
  providers,
}) => {
  const queryClient = useQueryClient();
  const modalRef = useRef(null);
  const [caseManager, setCaseManager] = useState([]);
  const [formData, setFormData] = useState({
    provider_id: "",
  });

  const [loading, setloading] = useState(false);

  useEffect(() => {
    const fetchCaseManager = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const account_id = sessionStorage.getItem("acc_id");

        const url = `${BASE_URL}/accounts/${account_id}/case-managers/`;
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const providers_ids = providers.map((_provider) => _provider.id);
        const caseManagers = response.data.filter(
          (_cm) => !providers_ids.includes(_cm.id)
        );

        // setCaseManager(response.data.filter((manager) => manager.active));
        setCaseManager(caseManagers);
      } catch (error) {
        handleApiError(error);
      }
    };

    fetchCaseManager();
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Ensure modalRef is defined and check if the click is outside the modal
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const addProvider = async (provider_id) => {
    try {
      setloading(true);
      const token = localStorage.getItem("authToken");
      const account_id = sessionStorage.getItem("acc_id");

      const url = `${BASE_URL}/accounts/${account_id}/staff/${provider_id}/provider/`;

      const response = await axios.patch(
        url,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success("New Provider added");
      queryClient.invalidateQueries(["providers"]);
      setloading(false);
      reRenderer(!render);
      onClose();
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    addProvider(Number(formData.provider_id));
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add Provider</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className={styles.input_wrapper}>
            <label>Name:</label>
            <Select
              onChange={(value) =>
                handleChange({
                  target: {
                    name: "provider_id",
                    value,
                  },
                })
              }
              value={formData.provider_id}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select provider">
                  {(() => {
                    const cm = caseManager?.find(
                      (_cm) => _cm.id === formData.provider_id
                    );
                    return cm
                      ? `${cm.first_name} ${cm.last_name}`
                      : "Select provider";
                  })()}
                </SelectValue>
              </SelectTrigger>
              <SelectContent>
                {caseManager.length > 0 ? (
                  caseManager?.map((manager) => (
                    <SelectItem key={manager.id} value={manager.id}>
                      {manager.first_name} {manager.last_name}
                    </SelectItem>
                  ))
                ) : (
                  <SelectItem>No Providers</SelectItem>
                )}
              </SelectContent>
            </Select>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose}>
            Close
          </Button>
          <Button
            onClick={handleSubmit}
            loading={loading}
            disabled={loading || !formData.provider_id}
          >
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddProviderModal;
